const LOGO_MAKER_COUNTRY_CODES = [

    // Africa
    'ke', 'mz', 'za',

    // East
    'ae', 'il', 'qa',

    // Asia
    'af', 'bn', 'hk', 'kr', 'mn', 'my', 'sa', 'sg', 'th', 'jp',

    // North America
    'aw', 'bb', 'bm', 'ca', 'us',

    // Central America
    'do', 'jm', 'gt', 'pa', 'pr',

    // South America
    'co',

    // Oceania
    'as', 'au', 'ck', 'fj', 'fm', 'gu', 'pf', 'ki', 'mh', 'mp', 'nc', 'nf', 'nr', 'nu', 'nz', 'pg', 'pn', 'pw',
    'sb', 'tk', 'tl', 'tv', 'vu', 'ws',

    // Europe
    'al', 'at', 'be', 'bg', 'ch', 'ck', 'cy', 'cz', 'de', 'dk', 'es', 'fi', 'fo', 'fr', 'gb', 'gi',
    'ie', 'im', 'is', 'je', 'li', 'lt', 'mc', 'md', 'me', 'mk', 'mt', 'nl', 'no', 'pt',
    'se', 'si', 'sk', 'sm', 'ua', 'va', 'xk'
];

const LOGO_MAKER_MIN_BUDGET = 30;
const BUDGET_FILTER = 'gig_price_range';
const LOGO_DESIGN_SUBCATEGORY_ID = 49;
const DEFAULT_LOCALE = 'en-US';
const SORTING_OPTIONS = {
    RATING: 'rating',
    AUTO: 'auto'
};
const QUERY_LIST = [
    'logo design',
    'logo',
    'branding',
    'logo design business',
    'versatile logo',
    'creative logo design',
    'logos',
    'logo designer',
    'professional logo',
    'design logo',
    'logo creation',
    'typography',
    'simple logo design',
    'simple logo design',
    'app logo',
    'logo creator',
    'branding kit',
    'brand logo',
    'elegant logo',
    'website logo',
    'logo makers',
    'initial logo',
    'professional logo design',
    'simple logo',
    'shopify logo',
    'create logo',
    'favicon',
    'personal logo',
    'business branding',
    'team logo',
    'website logo design',
    'design a logo',
    'business logo',
    'business logo design',
    'real estate logo',
    'minimalist logo design',
    'logos design',
    'company logo design',
    'Logo maker',
    'company logo',
    'youtube logo',
    'Logo design',
    'minimalist logo',
    'youtube logo design',
    'clothing brand logo',
    '3d logo',
    '3d logo design',
    'minimalist logo',
    'hand drawn logo',
    'hand drawn logo design',
    'vintage logo',
    'vintage logo design',
    'watercolor logo',
    'geometric logo',
    'geometric logo design',
    'graphic design logos',
    'beauty logo',
    'design company logo'
];

module.exports = {
    LOGO_MAKER_COUNTRY_CODES,
    LOGO_MAKER_MIN_BUDGET,
    BUDGET_FILTER,
    LOGO_DESIGN_SUBCATEGORY_ID,
    DEFAULT_LOCALE,
    SORTING_OPTIONS,
    QUERY_LIST
};
